import { Vertical } from '@sbt-web/adv';
import { ADSENSE_STYLES } from '@/client/components/Adv/AdSense';
import { LiraContainerIds } from '@/client/components/Adv/Lira/liraContainerIds';

type AdSenseStyleConfig = {
  channel_id: string;
  style_id: string;
};

type AdSenseDeviceConfig = {
  desktop: Record<Vertical, AdSenseStyleConfig>;
  msite?: Record<Vertical, AdSenseStyleConfig>;
};

const adsenseConfig: Record<string, AdSenseDeviceConfig> = {
  [LiraContainerIds.listing.inContentBottom]: {
    desktop: {
      motors: {
        channel_id: 'DESKTOP-BOTTOM-LP-MOTORS-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.DESKTOP_SHOPPING_LIGHT_MOTORS,
      },
      jobs: {
        channel_id: 'DESKTOP-BOTTOM-LP-JOBS-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.DESKTOP_SHOPPING_LIGHT_JOBS,
      },
      market: {
        channel_id: 'DESKTOP-BOTTOM-LP-MARKET-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.DESKTOP_SHOPPING_LIGHT_MARKET,
      },
      realestate: {
        channel_id: 'DESKTOP-BOTTOM-LP-REALESTATE-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.DESKTOP_SHOPPING_LIGHT_REALESTATE,
      },
      subito: {
        channel_id: 'DESKTOP-BOTTOM-LP-TUTTI-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.DESKTOP_SHOPPING_LIGHT_TUTTI,
      },
    },
    msite: {
      motors: {
        channel_id: 'MSITE-BOTTOM-LP-MOTORS-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.MOBILE_SHOPPING_LIGHT_MOTORS,
      },
      jobs: {
        channel_id: 'MSITE-BOTTOM-LP-JOBS-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.MOBILE_SHOPPING_LIGHT_JOBS,
      },
      market: {
        channel_id: 'MSITE-BOTTOM-LP-MARKET-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.MOBILE_SHOPPING_LIGHT_MARKET,
      },
      realestate: {
        channel_id: 'MSITE-BOTTOM-LP-REALESTATE-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.MOBILE_SHOPPING_LIGHT_REALESTATE,
      },
      subito: {
        channel_id: 'MSITE-BOTTOM-LP-TUTTI-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.MOBILE_SHOPPING_LIGHT_TUTTI,
      },
    },
  },
  [LiraContainerIds.listing.inContentTop]: {
    desktop: {
      motors: {
        channel_id: 'DESKTOP-TOP-LP-MOTORS-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.NO_SHOPPING_DESKTOP_SEARCH_LIGHT_MOTORS,
      },
      jobs: {
        channel_id: 'DESKTOP-TOP-LP-JOBS-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.NO_SHOPPING_DESKTOP_SEARCH_LIGHT_JOBS,
      },
      market: {
        channel_id: 'DESKTOP-TOP-LP-MARKET-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.NO_SHOPPING_DESKTOP_SEARCH_LIGHT_MARKET,
      },
      realestate: {
        channel_id: 'DESKTOP-TOP-LP-REALESTATE-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.NO_SHOPPING_DESKTOP_SEARCH_LIGHT_REALESTATE,
      },
      subito: {
        channel_id: 'DESKTOP-TOP-LP-TUTTI-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.NO_SHOPPING_DESKTOP_SEARCH_LIGHT_TUTTI,
      },
    },
    msite: {
      motors: {
        channel_id: 'MSITE-TOP-LP-MOTORS-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.NO_SHOPPING_MOBILE_SEARCH_LIGHT_MOTORS,
      },
      jobs: {
        channel_id: 'MSITE-TOP-LP-JOBS-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.NO_SHOPPING_MOBILE_SEARCH_LIGHT_JOBS,
      },
      market: {
        channel_id: 'MSITE-TOP-LP-MARKET-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.NO_SHOPPING_MOBILE_SEARCH_LIGHT_MARKET,
      },
      realestate: {
        channel_id: 'MSITE-TOP-LP-REALESTATE-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.NO_SHOPPING_MOBILE_SEARCH_LIGHT_REALESTATE,
      },
      subito: {
        channel_id: 'MSITE-TOP-LP-TUTTI-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.NO_SHOPPING_MOBILE_SEARCH_LIGHT_TUTTI,
      },
    },
  },
  [LiraContainerIds.listing.zeroResult]: {
    desktop: {
      subito: {
        channel_id: 'DESKTOP-TOP-0RESULTS-TUTTI-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.DESKTOP_SHOPPING_LIGHT_TUTTI,
      },
      jobs: {
        channel_id: 'DESKTOP-TOP-0RESULTS-JOBS-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.DESKTOP_SHOPPING_LIGHT_JOBS,
      },
      motors: {
        channel_id: 'DESKTOP-TOP-0RESULTS-MOTORS-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.DESKTOP_SHOPPING_LIGHT_MOTORS,
      },
      market: {
        channel_id: 'DESKTOP-TOP-0RESULTS-MARKET-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.DESKTOP_SHOPPING_LIGHT_MARKET,
      },
      realestate: {
        channel_id: 'DESKTOP-TOP-0RESULTS-REALESTATE-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.DESKTOP_SHOPPING_LIGHT_REALESTATE,
      },
    },
    msite: {
      subito: {
        channel_id: 'MSITE-TOP-0RESULTS-TUTTI-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.MOBILE_SHOPPING_LIGHT_TUTTI,
      },
      jobs: {
        channel_id: 'MSITE-TOP-0RESULTS-JOBS-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.MOBILE_SHOPPING_LIGHT_JOBS,
      },
      motors: {
        channel_id: 'MSITE-TOP-0RESULTS-MOTORS-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.MOBILE_SHOPPING_LIGHT_MOTORS,
      },
      market: {
        channel_id: 'MSITE-TOP-0RESULTS-MARKET-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.MOBILE_SHOPPING_LIGHT_MARKET,
      },
      realestate: {
        channel_id: 'MSITE-TOP-0RESULTS-REALESTATE-0-LIGHT-NO',
        style_id: ADSENSE_STYLES.MOBILE_SHOPPING_LIGHT_REALESTATE,
      },
    },
  },
};

export const getAdSenseConfig = (
  containerId: string,
  vertical: Vertical,
  isMsite: boolean
): AdSenseStyleConfig | undefined => {
  const config = adsenseConfig[containerId];
  if (config) {
    const deviceConfig = isMsite ? config.msite : config.desktop;
    try {
      return deviceConfig?.[vertical];
    } catch {
      return;
    }
  }
};
